var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#00914C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4703 3.5C10.756 3.50616 11.1013 3.67364 11.1628 3.9905C11.2461 4.28731 11.1843 4.55261 10.9753 4.77421C10.7126 5.0526 10.4392 5.31791 10.1761 5.59592L7.42567 8.45865C6.96898 8.93013 6.52771 9.41521 6.06148 9.8781C5.73029 10.2069 5.43645 10.6783 4.90577 10.4309C4.76988 10.3691 4.6671 10.2665 4.56193 10.1609C4.11015 9.70745 3.67948 9.22753 3.23262 8.76975C3.01576 8.55008 2.80079 8.32841 2.58771 8.10478C2.47972 7.99317 2.331 7.85671 2.24082 7.72932C1.8266 7.14419 2.38531 6.35152 3.04421 6.61547C3.2454 6.69608 3.35641 6.84035 3.50658 6.99855L4.00218 7.52898C4.39037 7.93883 4.78793 8.33274 5.17874 8.73988L8.43434 5.3526C8.73699 5.03435 9.04441 4.72769 9.34924 4.41188C9.58875 4.16372 9.82333 3.87853 10.0848 3.65123C10.1993 3.55168 10.3249 3.51794 10.4703 3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.75ad1840236c906ae5147b999c17a2cf.svg";
export { ForwardRef as ReactComponent };